import RouterFrame from '../../../../components/share/RouterFrame.vue'
import FinanceStateListing from '../../../../components/bundles/finance/admin/state/Listing.vue'

export default function (service, name) {
  return {
    path: 'stany-procesu',
    component: RouterFrame,
    meta: {
      title: 'Stany procesu',
      icon: 'disc',
      menuLink: true,
      acl: {
        service: service,
        action: 'get_workflow_states'
      }
    },
    children: [
      {
        path: '',
        component: FinanceStateListing,
        name: `${service}_state_listing`,
        meta: {
          title: 'Lista stanów procesu',
          acl: {
            service: service,
            action: 'get_workflow_states'
          }
        }
      }
    ]
  }
}
